import axios from "axios";
// import Swal from "sweetalert2";
const state = {
  lstServices: [],
};
const mutations = {
  SET_SERVICES(state, data) {
   
    state.lstServices = data;
  },
};
const actions = {
  async cargarServicios({ commit }, data) {
    var config = {
      method: "get",
      url: process.env.VUE_APP_URL_MAIN + "calc/servicio",
      headers: {
        "auth-token": sessionStorage.getItem("auth-token"),
        "Content-Type": "application/json",
      },
      params: data,
    };
    await axios(config)
      .then(function (response) {
        let data = response.data;
        if (data.estadoflag) {
          let services = data.data.map((v) => {
            let checked = true;
            if (v.code === "01" || v.code === "02") {
              checked = true;
            }
            return { ...v, checked };
          });
          commit("SET_SERVICES", services);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
